import { DATA_DEFINITION_PREFIX } from '../../constants';

export const JACOBY_TRANSFER_COMPLETE = 'bid-options/jacoby-accept/JACOBY_TRANSFER_COMPLETE';
export const DEF_JACOBY_TRANSFER_COMPLETE = DATA_DEFINITION_PREFIX+'bid-options/jacoby-accept/JACOBY_TRANSFER_COMPLETE';
export const JACOBY_TRANSFER_SUPER_COMPLETE = 'bid-options/jacoby-accept/JACOBY_TRANSFER_SUPER_COMPLETE';
export const DEF_JACOBY_TRANSFER_SUPER_COMPLETE = DATA_DEFINITION_PREFIX+'bid-options/jacoby-accept/JACOBY_TRANSFER_SUPER_COMPLETE';
